import script from "./OrderAdjustmentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAdjustmentDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderAdjustmentDetail.vue?vue&type=style&index=0&id=5732cdf6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5732cdf6"]])

export default __exports__